import userReducer from "./user";
import authReducer from "./auth";
import storeReducer from "./store";
import orderReducer from "./order";
import siderReducer from "./sider";
import notifyReducer from "./notify";
import productReducer from "./product";
import paymentReducer from "./payment";
import customerReducer from "./customer";
import categoryReducer from "./category";
import merchantReducer from "./merchant";
import orderListReducer from "./orderList";
import departmentReducer from "./department";
import breadcrumbReducer from "./breadcrumb";
import igwExtensionReducer from "./IGWExtension";
import productSearchReducer from "./productSearch";

export const reducer = {
  user: userReducer,
  auth: authReducer,
  store: storeReducer,
  order: orderReducer,
  sider: siderReducer,
  notify: notifyReducer,
  payment: paymentReducer,
  product: productReducer,
  merchant: merchantReducer,
  customer: customerReducer,
  category: categoryReducer,
  orderList: orderListReducer,
  department: departmentReducer,
  breadcrumb: breadcrumbReducer,
  igwExtension: igwExtensionReducer,
  productSearch: productSearchReducer,
};
